<script setup>
import { ref, computed } from 'vue';
import { useCompaniesStore } from 'dashboard/stores/companies';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['export']);

const { t } = useI18n();
const companiesStore = useCompaniesStore();

const dialogRef = ref(null);

const uiFlags = computed(() => companiesStore.getUIFlags);
const isExporting = computed(() => uiFlags.value.isExporting);

const handleDialogConfirm = async () => {
  emit('export');
  dialogRef.value?.close();
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('COMPANIES_LAYOUT.HEADER.ACTIONS.EXPORT.TITLE')"
    :description="t('COMPANIES_LAYOUT.HEADER.ACTIONS.EXPORT.DESCRIPTION')"
    :confirm-button-label="t('COMPANIES_LAYOUT.HEADER.ACTIONS.EXPORT.CONFIRM')"
    :is-loading="isExporting"
    :disable-confirm-button="isExporting"
    @confirm="handleDialogConfirm"
  />
</template>
